// src/features/executive/sales/drill/TopProductsDrill.tsx
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useTopProducts } from '../hooks/use-top-products'
import DrillTable from 'features/executive/components/DrillTable/DrillTable'
import type { ExecutiveState } from 'app/slice/executive.slice'
import { formatCurrency } from 'utils/executive.utils'
import { useRegisterDrillExport } from 'features/executive/components/DrillDrawer/DrillExportContext'

export default function TopProductsDrill() {
  const { t } = useTranslation()
  const stack = useSelector((s: { executive: ExecutiveState }) => s.executive.drillStack)
  const top = stack[stack.length - 1]
  const { data, loading, error, refetch } = useTopProducts(top?.scopedFilters)

  const widgetTitle = top?.label ?? t('EXECUTIVE.SALES.TOP_PRODUCTS.TITLE')
  useRegisterDrillExport(
    data ? { drillId: 'top-products', data } : null,
    'sales.top-products',
    widgetTitle
  )

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {top?.label ?? t('EXECUTIVE.SALES.TOP_PRODUCTS.TITLE')}
      </Typography>
      <DrillTable
        rows={data?.items ?? []}
        columns={[
          { key: 'rank', label: t('EXECUTIVE.SALES.COLUMN.RANK'), render: (_r, idx) => idx + 1 },
          { key: 'name', label: t('EXECUTIVE.SALES.COLUMN.NAME'), render: (r) => r.productName },
          { key: 'units', label: t('EXECUTIVE.SALES.COLUMN.UNITS'), align: 'right', render: (r) => r.unitsSold },
          { key: 'revenue', label: t('EXECUTIVE.SALES.COLUMN.REVENUE'), align: 'right', render: (r) => formatCurrency(r.revenue) },
        ]}
        loading={loading}
        error={error}
        onRetry={refetch}
      />
    </Box>
  )
}
